module.exports = __webpack_public_path__ + "media/images/infinite_circle-09498299.svg";